<template>
  <div
    v-closable="{ exclude: ['contextInfoWrapper'], isClosable: isClosable, handler: 'closeEditable'}"
  >
    <div
      :ref="'contextInfoWrapper'"
      class="context--info__container"
      :class="{'editing': isEditable, 'editable': eventName !== null && !isLoading}"
      @[eventName]="openEditable"
    >
      <template v-if="!flagHideOnEdit">
        <div v-if="icon !== null && !isLoading" class="context--info__icon">
          <v-tooltip left :disabled="iconTooltip === null">
            <template v-slot:activator="{ on }">
              <i v-on="on" :class="icon"></i>
            </template>
            <span>{{ iconTooltip }}</span>
          </v-tooltip>
        </div>
        <div v-else-if="isLoading" class="context--info__icon placeholderLoader">
          <i :class="icon"></i>
        </div>
        <div v-if="isLoading" class="context--info__text">
          <span class="attribute placeholderLoader">loading</span>
          <span class="value placeholderLoader">loading</span>
        </div>
        <div v-else-if="customText !== null" v-html="customText" class="context--info__text"></div>
        <div v-else class="context--info__text">
          <a target="_blank" v-if="hrefLink !== null" :href="hrefLink">
            <span v-show="attribute !== null" class="attribute">{{ attribute }}</span>
          </a>
          <span
            v-else
            v-show="attribute !== null && !isAttributeEditable && !isAutocompleteAttributeEditable"
            class="attribute"
          >{{ attribute }}</span>
          <input
            v-show="isAttributeEditable && !customAttributeEdit"
            @input="handleAttributeEditableInput"
            class="editable--attribute"
            :type="computedAttributeType"
            :value="contentAttribute"
            :ref="editableAttributeID"
          />
          <input
            v-show="isAutocompleteAttributeEditable && !customAttributeEdit"
            @input="handleAutocompleteAttributeEditableInput"
            class="editable--attribute"
            :type="computedAttributeType"
            :value="acAttrValue"
            :placeholder="attributePlaceholder"
            :ref="editableAutocompleteAttributeID"
          />
          <span
            v-show="value !== null && !isValueEditable"
            class="value"
          >{{ value }}{{ valueMeasurement }}</span>
          <input
            v-show="isValueEditable && !customValueEdit"
            @input="handleValueEditableInput"
            class="editable--value"
            :type="computedValueType"
            :value="contentValue"
            :ref="editableValueID"
          />
          <span v-show="isValueEditable && !customValueEdit" class="value">{{ valueMeasurement }}</span>
          <span v-show="isEditable" :ref="'slotEditableValue'">
            <slot
              :isOpen="isEditable"
              :openEdit="openEditable"
              :closeEdit="closeEditable"
              name="editValue"
            ></slot>
          </span>
          <span v-show="isEditable" :ref="'slotEditableAttribute'">
            <slot
              :isOpen="isEditable"
              :openEdit="openEditable"
              :closeEdit="closeEditable"
              name="editAttribute"
            ></slot>
          </span>
        </div>
      </template>
      <div v-if="isEditable" class="context--info__edit">
        <slot
          :isOpen="isEditable"
          :openEdit="openEditable"
          :closeEdit="closeEditable"
          name="editInfo"
        ></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { uuid } from 'vue-uuid'
export default {
  name: 'ContextInfo',
  props: {
    contextInfoID: { type: String, default: null },
    icon: { type: String, default: null },
    attribute: { value: String | Number, default: null },
    value: { value: String | Number, default: null },
    valueMeasurement: { type: String, deafult: '' },
    isLoading: { type: Boolean, default: false },
    eventName: { type: String, default: null },
    eventHandler: { type: Object, default: () => {} },
    customText: { type: String, default: null },
    hideValueOnEdit: { type: Boolean, default: false },
    hideAttributeOnEdit: { type: Boolean, default: false },
    isAutocompleteAttribute: { type: Boolean, default: false },
    customValueEdit: { type: Boolean, default: false },
    customAttributeEdit: { type: Boolean, default: false },
    hrefLink: { type: String, default: null },
    isClosable: { type: Boolean, default: true },
    onClickHandler: { type: Function, default: () => 1 },
    iconTooltip: { type: String, default: null }
  },
  data () {
    return {
      isEditable: false,
      isValueEditable: false,
      isAttributeEditable: false,
      isAutocompleteAttributeEditable: false,
      flagHideOnEdit: false,
      editableAttributeID: null,
      editableAutocompleteAttributeID: null,
      editableValueID: null,
      contentAttribute: this.attribute,
      contentValue: this.value,
      acAttrValue: null
    }
  },
  mounted () {
    this.editableAttributeID = uuid.v4()
    this.editableValueID = uuid.v4()
    this.editableAutocompleteAttributeID = uuid.v4()
  },
  methods: {
    openEditable (evt) {
      this.$nextTick(() => {
        if (this.hideAttributeOnEdit) {
          setTimeout(() => {
            this.$refs[this.editableAttributeID].focus()
          }, 20)
        }
        if (this.hideValueOnEdit) {
          setTimeout(() => {
            this.$refs[this.editableValueID].focus()
          }, 20)
        }
        if (this.isAutocompleteAttribute) {
          setTimeout(() => {
            this.$refs[this.editableAutocompleteAttributeID].focus()
          }, 20)
        }
      })
      if (evt.target.id === 'closeEdit') {
        this.isEditable = false
        // this.flagHideOnEdit = false
        this.isValueEditable = false
        this.isAttributeEditable = false
      } else {
        if (this.hideValueOnEdit) {
          if (
            this.$refs['slotEditableValue'].contains(evt.target) &&
            this.customValueEdit
          ) {
            this.isValueEditable = true
          } else {
            this.isValueEditable = !this.isValueEditable
          }
          if (this.isValueEditable) {
            this.onClickHandler()
          }
        }
        if (this.hideAttributeOnEdit) {
          if (
            this.$refs['slotEditableAttribute'].contains(evt.target) &&
            this.customAttributeEdit
          ) {
            this.isAttributeEditable = true
          } else {
            this.isAttributeEditable = !this.isAttributeEditable
          }
          if (this.isAttributeEditable) {
            this.onClickHandler()
          }
        }
        if (this.isAutocompleteAttribute) {
          this.contentAttribute = this.attribute
          this.isAutocompleteAttributeEditable = !this
            .isAutocompleteAttributeEditable
          if (!this.isAutocompleteAttributeEditable) {
            this.acAttrValue = null
          }
        }
        if (this.customValueEdit) {
          if (!this.$refs['slotEditableValue'].contains(evt.target)) {
            this.isEditable = !this.isEditable
          }
        }
        if (this.customAttributeEdit) {
          if (!this.$refs['slotEditableAttribute'].contains(evt.target)) {
            this.isEditable = !this.isEditable
          }
        }
        if (!this.customValueEdit && !this.customAttributeEdit) {
          this.isEditable = !this.isEditable
        }
      }
    },
    closeEditable (evt) {
      this.isEditable = false
      this.flagHideOnEdit = false
      this.isValueEditable = false
      this.isAttributeEditable = false
      this.isAutocompleteAttributeEditable = false
      this.contentAttribute = this.attribute
      this.acAttrValue = null
    },
    handleAttributeEditableInput (evt) {
      this.contentAttribute = evt.target.value
      this.$emit('input-attribute', this.contentAttribute)
    },
    handleValueEditableInput (evt) {
      this.contentValue = evt.target.value
      this.$emit('input-value', this.contentValue)
    },
    handleAutocompleteAttributeEditableInput (evt) {
      this.contentAttribute = evt.target.value
      this.acAttrValue = evt.target.value
      this.$emit('input-attribute', this.contentAttribute)
    }
  },
  computed: {
    computedValueType: function () {
      return this.attribute !== null ? typeof this.attribute : 'text'
    },
    computedAttributeType: function () {
      return this.value !== null ? typeof this.value : 'text'
    },
    attributePlaceholder: function () {
      return this.attribute
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
